import template from './holiday.html';
import controller from './holiday.controller';
import './holiday.scss';
import 'fullcalendar/dist/fullcalendar.css';

let HolidayComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template,
  controller
};

export default HolidayComponent;

     


// WEBPACK FOOTER //
// ./client/app/components/holiday/holiday.component.js